module.exports = "https://static.wanderu.com/static/media/de.7e82f4c7.svg";